import {css, CSSResult} from "lit";

export const sharedStyles: CSSResult = css`
    .typewriter {
        overflow: hidden;
        white-space: nowrap;
        animation: typewriter 4s steps(40);
    }

    @keyframes typewriter {
        from {
            width: 0;
            border-right: .15em solid #00FF00
        }
        to {
            width: 100%;
            border-right: .15em solid #00FF00
        }
    }
  `;